import {
  parseOnlyNumericValue,
  safeToString,
  sliceText,
} from "../../../utils/common";

export const BONUS_STATUS_FIELDS = [
  {
    name: "bonus_status",
    label: "Bonus Status",
    inputType: "selectField",
    component: "SelectField",
    options: [
      { id: true, name: "Yes" },
      { id: false, name: "No" },
    ],
    fullWidth: true,
    placeholder: "Select Here...",
    customOptions: {
      boolean: true,
    },
  },
  {
    name: "ex_gratia",
    label: "Ex Gratia",
    inputType: "selectField",
    component: "SelectField",
    fullWidth: true,
    options: [
      { id: true, name: "Yes" },
      { id: false, name: "No" },
    ],
    placeholder: "Select Here...",
    customOptions: {
      boolean: true,
    },
  },
  {
    name: "incentive_application",
    label: "Incentive Application",
    inputType: "selectField",
    component: "SelectField",
    options: [
      { id: true, name: "Yes" },
      { id: false, name: "No" },
    ],
    fullWidth: true,
    placeholder: "Select Here...",
    customOptions: {
      boolean: true,
    },
  },
  {
    name: "ot_application",
    label: "OT Application",
    inputType: "selectField",
    component: "SelectField",
    fullWidth: true,
    options: [
      { id: true, name: "Yes" },
      { id: false, name: "No" },
    ],
    placeholder: "Select Here...",
    customOptions: {
      boolean: true,
    },
  },
  {
    name: "labour_welfare_fund",
    label: "Labour Welfare Fund",
    inputType: "selectField",
    component: "SelectField",
    options: [
      { id: true, name: "Yes" },
      { id: false, name: "No" }
    ],
    placeholder: "Select Here...",
    customOptions: {
      boolean: true
    }
  }
];

export const EMP_SETUP_CONST = {
  employmentType: {
    fullWidth: true,
    label: "Employment Type",
    options: [
      { id: "full_time", name: "Permanent" },
      { id: "probationary", name: "Provision Period"},
      { id: "part_time", name: "Part Time", disabled: true },
      { id: "contractual", name: "Contractual", disabled: true },
    ],
    multiSelect: true,
    searchable: false,
    clearable: true,
    placeholder: "Select Here...",
    name: "employmentType",
    required: true,
  },
  isProvisionPeriod: {
    name: "isProvisionPeriod",
    fullWidth: true,
    label: "Provision Period",
    options: [
      { id: true, name: "Yes" },
      { id: false, name: "No" },
    ],
    placeholder: "Select Here...",
  },
  provisionDays: {
    required: true,
    name: "provisionDays",
    type: "number",
    fullWidth: true,
    label: "Provision Days",
    placeholder: "Type Here...",
    customOptions: {
      formatValueFn: (value) => {
        return sliceText(parseOnlyNumericValue(safeToString(value)), 2);
      },
    },
  },
  isNoticePeriod: {
    name: "isNoticePeriod",
    fullWidth: true,
    label: "Notice Period",
    options: [
      { id: true, name: "Yes" },
      { id: false, name: "No" },
    ],
    placeholder: "Select Here...",
  },
  noticeDays: {
    name: "noticeDays",
    type: "number",
    fullWidth: true,
    required: true,
    label: "Notice days",
    placeholder: "Type Here...",
    customOptions: {
      formatValueFn: (value) => {
        return sliceText(parseOnlyNumericValue(safeToString(value)), 2);
      },
    },
  },
  prefix: {
    name: "prefix",
    type: "text",
    fullWidth: true,
    required: true,
    label: "Emp Code Prefix",
    placeholder: "Type Here...",
  },

  leave_type: {
    fullWidth: true,
    required: true,
    name: "leave_type",
    label: "Leave Period",
    options: [
      { id: "calender_year", name: "Calendar Year" },
      { id: "financial_year", name: "Financial Year" },
    ],
    placeholder: "Select Here...",
  },
  leave_staging: {
    fullWidth: true,
    required: true,
    name: "leave_staging",
    label: "Weekly Off",
    placeholder: "Select Here...",
    options: [
      { id: true, name: "Organization Level" },
      { id: false, name: "Employee Level" },
    ],
  },
  workMode: {
    fullWidth: true,
    multiSelect: true,
    searchable: true,
    clearable: true,
    label: "Work Location",
    required: true,
    options: [
      { id: "Work-From-Home", name: "Work From Home" },
      { id: "Work-From-Office", name: "Work From Office" },
      { id: "On-Site", name: "On-Site" },
    ],
    placeholder: "Select Here...",
  },
  shiftManagement: {
    name: "shiftManagement",
    fullWidth: true,
    label: "Shift Management",
    options: [
      { id: true, name: "Yes" },
      { id: false, name: "No" },
    ],
    placeholder: "Select Here...",
  },
  loginTime: {
    name: "loginTime",
    type: "time",
    fullWidth: true,
    label: "Login Time",
    placeholder: "Type Here...",
    valueSinc: true,
    required: true,
  },
  logoutTime: {
    name: "logoutTime",
    type: "time",
    fullWidth: true,
    label: "Logout Time",
    placeholder: "Type Here...",
    valueSinc: true,
    required: true,
  },
  breakTime: {
    name: "breakTime",
    type: "number",
    fullWidth: true,
    label: "Break Time",
    placeholder: "Type Here...",
    prefix: "min",
    required: true,
    customOptions: {
      formatValueFn: (value) => {
        return sliceText(parseOnlyNumericValue(safeToString(value)), 2);
      },
    },
  },
};

export const ORGANIZATION_BENEFIT_API = {
  ORGANIZATION_BENEFIT_GET: {
    url: "organization/get-organization-benefit",
    method: "GET",
  },
};
